export default {
  errorDefault: 'Der opstod en fejl',
  unknown: 'Ukendt',
};
